import Vue from 'vue';
import moment from 'moment';
import vueMoment from 'vue-moment';
import 'moment/locale/ru';
import _ from 'lodash';

Vue.use(vueMoment, {
  moment,
});

declare module 'vue/types/vue' {
  interface VueConstructor {
    moment: any;
  }
}
